import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * Explains that location sharing is required to use the app / create dispense events.
 *
 * - mode 'prompt'  : asks the user to enable location; "Enable Location" resolves true.
 * - mode 'denied'  : location is blocked at the browser/OS level and cannot be re-prompted
 *                    programmatically, so we show instructions for re-enabling it in settings.
 *
 * Result is returned via NgbActiveModal.close(boolean); a dismissal is treated as false.
 */
@Component({
    selector: 'pcg-location-permission-modal',
    templateUrl: './location-permission-modal.component.html',
    styleUrls: ['./location-permission-modal.component.scss'],
    standalone: false,
})
export class LocationPermissionModalComponent {
    @Input() mode: 'prompt' | 'denied' = 'prompt';

    constructor(public activeModal: NgbActiveModal) {}

    accept() {
        this.activeModal.close(true);
    }

    deny() {
        this.activeModal.close(false);
    }

    close() {
        this.activeModal.close(false);
    }
}
